type LatestSearches = string[];

export const latestSearchesMock = [] satisfies LatestSearches;

export const getLatestSearches = () => {
  const latestSearches = sessionStorage.getItem('latest-searches');

  if (!latestSearches) {
    return [];
  }

  return JSON.parse(latestSearches) as string[];
};

export const setLatestSearches = (value: string) => {
  const latestSearches = getLatestSearches();

  if (
    latestSearches.find(
      (latestSearch) => latestSearch.trim().toLowerCase() === value.trim().toLowerCase(),
    )
  ) {
    return;
  }

  sessionStorage.setItem(
    'latest-searches',
    JSON.stringify([...getLatestSearches(), value.trim()].slice(-5)),
  );
};
